<template>
  <div class="RiskmannNavbarNotificaciones">
    <div class="offcanvas offcanvas-bottom rounded" tabindex="-1" id="notificacionNavbar"
      aria-labelledby="notificacionNavbarLabel">
      <div class="offcanvas-header">
        <h5 class="offcanvas-title fw-bold" id="notificacionNavbarLabel">
          Notificaciones
        </h5>
        <button id="notificaciones-btn-close" type="button" class="btn-close" data-bs-dismiss="offcanvas"
          aria-label="Close"></button>
      </div>
      <div class="offcanvas-body justify-content-start">
        <ListaNotificaciones />
      </div>
    </div>
  </div>
</template>

<script>
import ListaNotificaciones from "./ListaNotificaciones.vue";
export default {
  name: "RiskmannNavbarNotificaciones",

  components: {
    ListaNotificaciones,
  },

  mounted() {
    document.getElementById("notificacionNavbar").addEventListener("hidden.bs.offcanvas", (event) => {
      this.$emit("mostrar", false);
    });
  },
};
</script>

<style scoped>
.offcanvas-body {
  overflow-y: hidden;
}

.offcanvas-bottom {
  height: 500px;
}
</style>
